export default __webpack_public_path__ + "static/pro@768-b28becfe1a1bbdb7759db0673a33fbc4.png";